import { Link, useLocation, Navigate } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { ScorekeeperLogo } from '../components/ScorekeeperLogo';
import { useAuth } from '../state/AuthContext';
import { paths } from '../lib/paths';

/**
 * Sign-in page. Single button, single source of truth: Google OAuth.
 *
 * If already signed in, route straight to /me (or whatever deep-link the
 * user came from, when applicable).
 */
export function SignInPage() {
  const { googleEmail, canAdmin, canSuperAdmin, isSignedIn, authReady } = useAuth();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from;

  const returnTo =
    from && (from.startsWith('/admin') || from.startsWith('/company') || from.startsWith('/me')) ? from : '/me';
  const googleHref = `/api/auth/google/login?return_to=${encodeURIComponent(returnTo)}`;

  if (authReady && isSignedIn && googleEmail) {
    const dest =
      from && from.startsWith('/company') && canSuperAdmin
        ? from
        : from && from.startsWith('/admin') && canAdmin
          ? from
          : '/me';
    return <Navigate to={dest} replace />;
  }

  return (
    <div className="m-signin">
      <div className="card" style={{ maxWidth: 420, margin: '60px auto', padding: 28 }}>
        <ScorekeeperLogo className="signin-card__logo" />
        <div className="row" style={{ gap: 10, alignItems: 'center', marginBottom: 14 }}>
          <ShieldCheck size={20} />
          <div>
            <div className="eyebrow">Sign in</div>
            <h2 style={{ margin: 0, fontSize: 22 }}>Welcome to The Scorekeeper</h2>
          </div>
        </div>

        <p className="muted" style={{ marginTop: 0 }}>
          Sign in with Google to access your hub. Admin access is gated by an
          email allowlist.
        </p>

        <a
          href={googleHref}
          className="btn btn--primary"
          style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}
        >
          Sign in with Google
        </a>

        <div style={{ marginTop: 22, textAlign: 'center' }}>
          <Link to={paths.marketingHome} className="muted" style={{ fontSize: 13 }}>
            ← Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
